import { OrderProductSearchLocationScreen } from '../../../../../screens';

// ─────────────────────────────────────────────────────────────────────────────

export default function Page() {
  return <OrderProductSearchLocationScreen />;
}
